<template>
	<el-dialog
		class="cart_dialog"
		:class="{ 'is-mobile-dialog': useMobileLayout }"
		:visible.sync="innerVisible"
		:fullscreen="useMobileLayout"
		:show-close="!useMobileLayout"
		:top="useMobileLayout ? '0' : '4vh'"
		:append-to-body="true"
		:modal="modal"
		:z-index="zIndex"
		:close-on-click-modal="closeOnClickModal"
		v-dialog-drag="{ handle: '.cart_title', disabled: useMobileLayout }"
		@update:visible="onVisible"
		@closed="$emit('closed')">
		<div class="cart_title" slot="title">
			<span class="cart_title_text">产品详情</span>
			<div v-if="useMobileLayout" class="cart_title_actions">
				<button
					type="button"
					class="cart_title_submit"
					@click.stop="$emit('submit', 'cartForm')">确认添加</button>
				<button
					type="button"
					class="cart_title_close"
					aria-label="关闭"
					@click.stop="closeSelf">
					<i class="el-icon-close"></i>
				</button>
			</div>
		</div>
		<el-form :rules="cartRules" ref="cartForm" label-position="top" :model="cartForm" class="cart_form">
			<el-row v-if="good && visible" class="cart_body" type="flex">
				<div class="cart_good">
					<el-row type="flex" align="middle" class="cart_good_t">
						<el-row type="flex" justify="center" align="middle" v-if="skuActive===-1" class="cart_good_img">
							<el-image fit="contain" :src="good.cart_info ? good.cart_info.goods_image_text : good.image">
								<div slot="error" class="image-slot">
									<i class="el-icon-picture-outline"></i>
								</div>
							</el-image>
						</el-row>
						<el-row type="flex" justify="center" align="middle" v-else class="cart_good_img">
							<el-image fit="contain" :src="good.skuPrice[skuActive].image_url">
								<div slot="error" class="image-slot">
									<i class="el-icon-picture-outline"></i>
								</div>
							</el-image>
						</el-row>
						<div class="cart_good_meta">
							<div class="cart_good_name">{{ good.cart_info ? good.cart_info.goods_name : good.name }}</div>
							<div class="cart_good_tip">{{ skuActive===-1 ? good.summary : good.skuPrice[skuActive].sn }}</div>
							<div class="cart_good_price">￥<span>{{ skuActive===-1 ? good.price : good.skuPrice[skuActive].price }}</span></div>
						</div>
					</el-row>
					<div v-if="good.is_sku==1" class="cart_good_specs">
						<div class="cart_good_specs_box" v-for="(item,index) in good.skuList" :key="index">
							<div class="cart_good_specs_name">{{ item.name }}</div>
							<el-row type="flex" class="cart_good_specs_content">
								<div
									@click="$emit('select-spec', idx, index)"
									class="cart_good_specs_item"
									:class="{'cart_good_specs_active': idx==item.activeIndex,'cart_good_specs_no': child.noStock}"
									v-for="(child,idx) in item.children"
									:key="idx">{{ child.name }}</div>
							</el-row>
						</div>
					</div>
					<div class="cart_good_params">
						<el-row type="flex" align="middle" class="cart_good_params_top">
							<div class="cart_good_params_title">产品参数</div>
							<div class="cart_good_params_tip">(<span>*</span>为必选项)</div>
						</el-row>
						<div class="cart_good_params_item" v-for="(item,index) in good.parameterList" :key="index" v-if="shouldShowParameterItem(item)">
							<el-row type="flex" class="cart_good_params_content">
								<div class="cart_good_params_name"><span v-if="item.must==1">*</span>{{ item.name }}</div>
								<el-form-item label="" class="cart_good_params_fields">
									<template v-if="isNestedParam(item)">
										<el-select @change="$emit('select-mid-param', index)" class="cart_good_params_select cart_good_params_select--mid" v-model="item.activeMidId" placeholder="请选择电压">
											<el-option v-for="mid in item.children" :key="'mid-'+mid.id" :label="mid.name" :value="mid.id"></el-option>
										</el-select>
										<el-select @change="$emit('select-param', $event, index)" class="cart_good_params_select" v-model="item.activeId" :disabled="!item.activeMidId" placeholder="请选择色温">
											<el-option v-if="item.must!=1" :key="'leaf-empty-'+index" label="请选择" :value="''"></el-option>
											<el-option v-for="leaf in leafOptionsForMid(item, item.activeMidId)" :key="leaf.id" :label="leaf.name" :value="leaf.id"></el-option>
										</el-select>
									</template>
									<template v-else>
										<el-select @change="$emit('select-param', $event, index)" class="cart_good_params_select" v-model="item.activeLabel" placeholder="请选择">
											<el-option v-for="(child,idx) in item.children" :key="child.id" :label="child.name" :value="child.id"></el-option>
										</el-select>
									</template>
								</el-form-item>
							</el-row>
						</div>
					</div>
				</div>
				<div class="cart_data">
					<div class="cart_panel cart_panel--result">
						<div class="cart_data_title">计算结果<span>{{ good.valuation_tips }}</span></div>
						<el-row type="flex" class="cart_data_cal">
							<div>
								<el-row v-if="good.valuation==4||good.valuation==5||good.valuation==7||good.valuation==12||good.valuation==13" type="flex" align="middle" class="cart_data_cal_item">
									<div class="cart_data_cal_dot"></div>
									<div v-if="!good.goods_areas||good.goods_areas==''" class="cart_data_cal_name">面积：<span class="cart_data_cal_wait">待测算</span></div>
									<div v-else class="cart_data_cal_name">面积：<span>{{ good.goods_areas }}</span>㎡</div>
								</el-row>
								<el-row type="flex" align="middle" class="cart_data_cal_item">
									<div class="cart_data_cal_dot"></div>
									<div v-if="!good.singleton||good.singleton==''" class="cart_data_cal_name">单件价格：<span class="cart_data_cal_wait">待测算</span></div>
									<div v-else class="cart_data_cal_name">单件价格：<span>{{ good.singleton }}</span>元</div>
								</el-row>
								<el-row type="flex" align="middle" class="cart_data_cal_item">
									<div class="cart_data_cal_dot"></div>
									<div v-if="good.discount_price===undefined||good.discount_price===null||good.discount_price===''" class="cart_data_cal_name">折扣价：<span class="cart_data_cal_wait">待测算</span></div>
									<div v-else-if="isSamePrice(good.discount_price, good.singleton)" class="cart_data_cal_name">折扣价：<span>-</span></div>
									<div v-else class="cart_data_cal_name">折扣价：<span class="amount--discount">{{ good.discount_price }}</span>元</div>
								</el-row>
							</div>
						</el-row>
					</div>
					<div class="cart_panel">
						<div class="cart_data_title">输入尺寸</div>
						<el-row type="flex" align="middle" class="cart_data_area">
							<div v-if="good.valuation==2||good.valuation==3||good.valuation==4||good.valuation==5||good.valuation==8||good.valuation==10||good.valuation==11||good.valuation==12||good.valuation==13" class="cart_data_area_item">
								<el-form-item label="长度(mm)">
									<input @input="cartForm.goods_long=cartForm.goods_long.replace(/[^\d]/g,'')" @change="$emit('price-init')" @blur="$emit('auto-cal-price')" v-model="cartForm.goods_long" class="cart_data_area_input" placeholder="请输入" />
								</el-form-item>
							</div>
							<div v-if="good.valuation==6||good.valuation==7||good.valuation==9" class="cart_data_area_item">
								<el-form-item label="高度(mm)">
									<input @input="cartForm.goods_high=cartForm.goods_high.replace(/[^\d]/g,'')" @change="$emit('price-init')" @blur="$emit('auto-cal-price')" v-model="cartForm.goods_high" class="cart_data_area_input" placeholder="请输入" />
								</el-form-item>
							</div>
							<div v-if="good.valuation==4||good.valuation==5||good.valuation==6||good.valuation==7||good.valuation==9||good.valuation==12||good.valuation==13" class="cart_data_area_item">
								<el-form-item label="宽度(mm)">
									<input @input="cartForm.goods_wide=cartForm.goods_wide.replace(/[^\d]/g,'')" @change="$emit('price-init')" @blur="$emit('auto-cal-price')" v-model="cartForm.goods_wide" class="cart_data_area_input" placeholder="请输入" />
								</el-form-item>
							</div>
							<div v-if="good.valuation==6||good.valuation==7||good.valuation==9" class="cart_data_area_item">
								<el-form-item label="厚度(mm)">
									<input @input="cartForm.goods_thick=cartForm.goods_thick.replace(/[^\d]/g,'')" @change="$emit('price-init')" @blur="$emit('auto-cal-price')" v-model="cartForm.goods_thick" class="cart_data_area_input" placeholder="请输入" />
								</el-form-item>
							</div>
						</el-row>
						<el-row type="flex" align="middle" class="cart_data_num">
							<div class="cart_data_num_text">数量</div>
							<el-input-number v-model="cartForm.goods_num" :min="isEditingPendingCart ? 0 : 1" label="数量"></el-input-number>
						</el-row>
					</div>
					<div class="cart_panel">
						<el-row type="flex" justify="space-between" align="bottom" class="cart_data_bottom">
							<el-form-item class="cart_data_remark" label="备注">
								<el-input type="textarea" v-model="cartForm.remarks" maxlength="-1" :autosize="{ minRows: 3, maxRows: 6}" resize="none" placeholder="选填，补充加工要求等"></el-input>
							</el-form-item>
							<div v-if="!useMobileLayout" class="cart_btn" @click="$emit('submit', 'cartForm')">确认添加</div>
						</el-row>
					</div>
					<div v-if="showUpload" class="cart_panel">
						<div class="cart_data_title">参考图片</div>
						<div class="cart_data_upload">
							<imageUpload ref="avatarUpload" v-model="cartForm.reference_image" :limit="uploadLimit" :fileType="fileType" />
						</div>
						<div class="cart_data_tip">注：格式限制为 jpg、jpeg、png、dxf、dws、dwg，小于 2M</div>
					</div>
				</div>
			</el-row>
		</el-form>
		<div v-if="useMobileLayout" class="cart_mobile_bar">
			<button type="button" class="cart_mobile_bar_btn" @click.stop="$emit('submit', 'cartForm')">确认添加</button>
		</div>
	</el-dialog>
</template>

<script>
	import ImageUpload from '@/components/ImageUpload'
	import dialogDrag from '@/directives/dialog-drag'
	import {
		isNestedParameter as isNestedParam,
		leafOptionsForMid,
		shouldShowParameterItem as isParameterItemVisible,
	} from '@/utils/cart-parameter'

	export default {
		name: 'CartDetailDialog',
		components: { ImageUpload },
		directives: { dialogDrag },
		props: {
			visible: { type: Boolean, default: false },
			isMobile: { type: Boolean, default: false },
			good: { type: Object, default: null },
			cartForm: { type: Object, required: true },
			cartRules: { type: Object, default: function() { return {} } },
			skuActive: { type: Number, default: -1 },
			isEditingPendingCart: { type: Boolean, default: false },
			uploadLimit: { type: Number, default: 6 },
			fileType: { type: Array, default: function() { return ['jpg', 'jpeg', 'png', 'dxf', 'dws', 'dwg'] } },
			modal: { type: Boolean, default: true },
			closeOnClickModal: { type: Boolean, default: true },
			zIndex: { type: Number, default: undefined },
			showUpload: { type: Boolean, default: true },
		},
		computed: {
			innerVisible: {
				get() { return this.visible },
				set(val) { this.$emit('update:visible', val) },
			},
			useMobileLayout() {
				if (this.isMobile) return true
				if (typeof document === 'undefined') return false
				return document.documentElement.classList.contains('is-mobile-viewport')
			},
		},
		methods: {
			onVisible(val) {
				this.$emit('update:visible', val)
			},
			closeSelf() {
				this.innerVisible = false
			},
			isNestedParam: isNestedParam,
			leafOptionsForMid: leafOptionsForMid,
			shouldShowParameterItem(item) {
				return isParameterItemVisible(item, this.good, this.skuActive)
			},
			isSamePrice(a, b) {
				const na = Number(a)
				const nb = Number(b)
				if (Number.isFinite(na) && Number.isFinite(nb)) {
					return Math.abs(na - nb) < 1e-6
				}
				const emptyA = a === undefined || a === null || a === ''
				const emptyB = b === undefined || b === null || b === ''
				return !!(emptyA && emptyB)
			},
			getForm() {
				return this.$refs.cartForm
			},
		},
	}
</script>
